import React from 'react';
import proptypes from 'prop-types';
const { string, bool } = proptypes;
import { Typography } from '@one-thd/sui-atomic-components';
import {
  LIVE_GOODS_IN_SEASON_NEW,
  LIVE_GOODS_OUT_OF_SEASON_NEW
} from '../../constants';

const LiveGoods = ({ storeName = null, seasonStatusEligible = false }) => {
  return (
    <div data-testid="fulfillment__unavailable" data-component="FulfillmentLiveGoods">
      <div>
        {seasonStatusEligible && (
          <>
            <Typography variant="h3" height="tight" color="success">{LIVE_GOODS_IN_SEASON_NEW}</Typography>
            <Typography variant="body-base" component="div">
              <div className="sui-pt-2">
                <span>Stop by{"\u00A0"}</span>
                <span className="sui-font-bold">{storeName}</span>
                <span>{"\u00A0"}to see this variety and more in person.</span>
              </div>
            </Typography>
          </>
        )}
        {!seasonStatusEligible && (
          <>
            <Typography variant="h3" height="tight">{LIVE_GOODS_OUT_OF_SEASON_NEW}</Typography>
            <Typography variant="body-base" component="div">
              <div className="sui-pt-2">
                <span>Visit{"\u00A0"}</span>
                <span className="sui-font-bold">{storeName}</span>
                <span>{"\u00A0"}next season to find this plant and more.</span>
              </div>
            </Typography>
          </>
        )}
      </div>
    </div>
  );
};

LiveGoods.propTypes = {
  storeName: string,
  seasonStatusEligible: bool
};

export { LiveGoods };
